import scrollTo from './ScrollTo';
export default scrollTo;
